﻿import { RoutingFlags } from '@constants/routingFlags';
import { routingFlagStore } from '@store/routingFlag/store';

/**
 * Checks if a routing flag has a specific value.
 * @param flag - The routing flag enum value (e.g., RoutingFlags.V4CarrierSearch)
 * @param value - The expected value to check against (defaults to 'Enabled')
 * @returns true if the flag exists and its value matches the expected value, false otherwise
 */
export const isRoutingFlagEnabled = (
  flag: RoutingFlags,
  value: string = 'Enabled',
): boolean => {
  const foundFlag = routingFlagStore.flags.find(
    (f) => f.id.toUpperCase() === flag.toUpperCase(),
  );

  return foundFlag?.value === value;
};
